import { Month } from '../generated-types';
export const getYears = numberOfYears => {
  const yearsArray = [{
    text: 'Velg',
    value: 'velg'
  }];
  for (let i = 0; i < numberOfYears; i += 1) {
    const yearString = (new Date().getFullYear() - i).toString();
    yearsArray.push({
      text: yearString,
      value: yearString
    });
  }
  return yearsArray;
};
export const getMonths = () => {
  return [{
    text: 'Velg',
    value: 'velg'
  }, {
    text: 'Januar',
    value: Month.JANUARY
  }, {
    text: 'Februar',
    value: Month.FEBRUARY
  }, {
    text: 'Mars',
    value: Month.MARCH
  }, {
    text: 'April',
    value: Month.APRIL
  }, {
    text: 'Mai',
    value: Month.MAY
  }, {
    text: 'Juni',
    value: Month.JUNE
  }, {
    text: 'Juli',
    value: Month.JULY
  }, {
    text: 'August',
    value: Month.AUGUST
  }, {
    text: 'September',
    value: Month.SEPTEMBER
  }, {
    text: 'Oktober',
    value: Month.OCTOBER
  }, {
    text: 'November',
    value: Month.NOVEMBER
  }, {
    text: 'Desember',
    value: Month.DECEMBER
  }];
};
export const getNorwegianMonth = monthName => {
  switch (monthName) {
    case Month.JANUARY:
      return 'januar';
    case Month.FEBRUARY:
      return 'februar';
    case Month.MARCH:
      return 'mars';
    case Month.APRIL:
      return 'april';
    case Month.MAY:
      return 'mai';
    case Month.JUNE:
      return 'juni';
    case Month.JULY:
      return 'juli';
    case Month.AUGUST:
      return 'august';
    case Month.SEPTEMBER:
      return 'september';
    case Month.OCTOBER:
      return 'oktober';
    case Month.NOVEMBER:
      return 'november';
    case Month.DECEMBER:
      return 'desember';
    default:
      return 'januar';
  }
};